// Cliente HTTP de los avisos de la cuenta (PP-68), mismo patron que
// sites/http.ts: token en el header, sin cookies ni redirecciones, y todo
// cuerpo (el que sale y el que vuelve) por el parser de @ucorp/contracts.
import { ProviderNotificationPreferences, UpdateProviderNotificationPreferencesRequest } from "@ucorp/contracts";
import { NotificationsError, type NotificationsPort } from "./port.js";

export function createHttpNotificationsPort(apiUrl: string, request: typeof fetch = fetch): NotificationsPort {
  const url = `${apiUrl.replace(/\/+$/, "")}/provider/notification-preferences`;

  async function call(accessToken: string, body?: unknown) {
    let response: Response;
    try {
      response = await request(url, {
        method: body === undefined ? "GET" : "PUT",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          ...(body === undefined ? {} : { "Content-Type": "application/json" }),
        },
        ...(body === undefined ? {} : { body: JSON.stringify(body) }),
        cache: "no-store",
        credentials: "omit",
        redirect: "error",
      });
    } catch {
      throw new NotificationsError();
    }
    if (!response.ok) throw new NotificationsError();
    const parsed = ProviderNotificationPreferences.safeParse(await response.json().catch(() => undefined));
    if (!parsed.success) throw new NotificationsError();
    return parsed.data;
  }

  return {
    read: (session) => call(session.accessToken),
    async save(session, value) {
      const body = UpdateProviderNotificationPreferencesRequest.safeParse(value);
      if (!body.success) throw new NotificationsError();
      return call(session.accessToken, body.data);
    },
  };
}
